module.exports = __webpack_public_path__ + "static/media/logo.15f672a2.svg";